import { render, staticRenderFns } from "./aiorder.vue?vue&type=template&id=1f975bbc&"
import script from "./aiorder.vue?vue&type=script&lang=js&"
export * from "./aiorder.vue?vue&type=script&lang=js&"
import style0 from "./aiorder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports